import { createFileRoute } from "@tanstack/react-router";
import { Secondaries } from "@/components/Secondaries";

function RouteComponent() {
  return <Secondaries />;
}

export const Route = createFileRoute("/_authenticated/secondaries/")({
  component: RouteComponent,
  staticData: { page: "deals" },
});
